import { render, staticRenderFns } from "./InvitationPage.vue?vue&type=template&id=7f4de2bb&lang=html&"
import script from "./InvitationPage.vue?vue&type=script&lang=js&"
export * from "./InvitationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4de2bb')) {
      api.createRecord('7f4de2bb', component.options)
    } else {
      api.reload('7f4de2bb', component.options)
    }
    module.hot.accept("./InvitationPage.vue?vue&type=template&id=7f4de2bb&lang=html&", function () {
      api.rerender('7f4de2bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Auth/InvitationPage.vue"
export default component.exports